import { Component, OnInit, ViewChild, TemplateRef, OnDestroy, ElementRef, AfterViewInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { NzModalService, NzModalRef } from 'ng-zorro-antd/modal';
import { FormService, Pattern } from 'src/app/services/form.service';
import { AngularFirestore } from '@angular/fire/firestore';
import { Router } from '@angular/router';
import { Subject, Subscription, Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { UploadFile } from 'ng-zorro-antd/upload';
import { UploadXHRArgs } from 'ng-zorro-antd/upload';
import { AngularFireStorage } from '@angular/fire/storage';
import { environment } from 'src/environments/environment';
import { NzMessageService } from 'ng-zorro-antd';
import { UploadChangeParam } from 'ng-zorro-antd/upload';

@Component({
  selector: 'app-form-press',
  templateUrl: './form-press.component.html',
  styleUrls: ['./form-press.component.css']
})
export class FormPressComponent implements OnInit, AfterViewInit, OnDestroy {

  validateForm: FormGroup;
  @ViewChild('errorModalTpl', { static: false }) private errorModalTpl: TemplateRef<any>;
  @ViewChild('errorModalTpll', { static: false }) private errorModalTpll: TemplateRef<any>;
  errorModal: NzModalRef;
  errorModale: NzModalRef;
  formData: FormService;
  isVideoLinkPreviewLoading: boolean = false;
  videoLinkKeyup: Subject<string> = new Subject<string>();
  private subscriptions: Subscription[] = [];
  videoPreviewData: object = null;
  isVideoLinkValid: boolean = false;
  @ViewChild('backgroundVideo', { static: false, read: ElementRef }) private backgroundVideo: ElementRef;
  showImagesUploadList = {
    showPreviewIcon: true,
    showRemoveIcon: true,
    hidePreviewIconInNonImage: true
  };
  imagesList: UploadFile[] = [];
  contImage: UploadFile[] = [];
  private imageFiles: { [key: string]: UploadFile } = {};
  private imagesFiles: { [key: string]: UploadFile } = {};
  imagePreview: string | undefined = '';
  isImagePreviewVisible: boolean = false;
  isLoading: boolean = false;

  constructor(
    private fb: FormBuilder,
    private modalService: NzModalService,
    private formService: FormService,
    private router: Router,
    private db: AngularFirestore,
    private storage: AngularFireStorage,
    private msg: NzMessageService
  ) {
    this.formData = this.formService;
    this.debug('cache', this.formData.getCache());
  }

  ngOnInit() {
    // Setup form fields
    this.validateForm = this.fb.group({
      // form part 1
      academy: [this.formData.getCache('academy'), [Validators.required]],
      direction: [this.formData.getCache('direction'), [Validators.required]],
      institute: [this.formData.getCache('institute'), [Validators.required]],
      website: [this.formData.getCache('website'), [Validators.pattern(Pattern.url)]],
      phone: [this.formData.getCache('phone'), [/*Validators.pattern(Pattern.number + '|' + Pattern.email)*/]],
      club: [this.formData.getCache('club'), []],
      participationYears: [this.formData.getCache('participationYears'), [Validators.required]],
      winYears: [this.formData.getCache('winYears'), []],
      // form part 2
      studentCategory: [this.formData.getCache('studentCategory', '15-18'), [Validators.required]],
      students: this.fb.array([ this.createStudentForm() ]),
      // form part 3
      teacher: this.fb.group({
        fullNameAr: [this.formData.getCache(['teacher', 'fullNameAr']), [Validators.required]],
        fullNameFr: [this.formData.getCache(['teacher', 'fullNameFr']), [Validators.required]],
        subjectOfSpecialisation: [this.formData.getCache(['teacher', 'subjectOfSpecialisation']), []],
        phone: [this.formData.getCache(['teacher', 'phone']), [/*Validators.pattern(Pattern.number + '|' + Pattern.email)*/]]
      }),
      objective: this.fb.group({
        number: [this.formData.getCache(['objective', 'number']), [Validators.required, Validators.pattern(Pattern.number), Validators.min(1), Validators.max(17)]],
        justification: [this.formData.getCache(['objective', 'justification']), [Validators.required]]
      }),
      // form part 4
      articleTitle: [null, [Validators.required]],
      doc: [[], [/*Validators.required, Validators.min(3)*/]],
      // form part 5
      images: [[], [/*Validators.required, Validators.min(3)*/]],
      // form part 6
      codeGresa: [this.formData.getCache('codeGresa'), [Validators.required]]
    });
  }

  ngAfterViewInit() {
    // Ensure that background video is played
    const media = this.backgroundVideo.nativeElement;
    media.muted = true;
    media.play();
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription: Subscription) => subscription.unsubscribe());
  }

  createStudentForm(): FormGroup {
    return this.fb.group({
      fullName: [null, [Validators.required]],
      birthDate: [null, [/*Validators.pattern(Pattern.date)*/]],
      level: [null, []],
      phone: [null, [Validators.pattern(Pattern.number)]],
      email: [null, [Validators.pattern(Pattern.email)]]
    });
  }

  submitForm(): void {
    for (const i in this.validateForm.controls) {
      if (this.validateForm.controls[i].constructor === FormArray) {
        const formArray = this.validateForm.controls[i] as FormArray;
        for (const f in formArray.controls) {
          const formGroup = formArray.controls[f] as FormGroup;
          for (const c in formGroup.controls) {
            formGroup.controls[c].markAsDirty();
            formGroup.controls[c].updateValueAndValidity();
          }
        }
      } else if (this.validateForm.controls[i].constructor === FormGroup) {
        const formGroup = this.validateForm.controls[i] as FormGroup;
        for (const c in formGroup.controls) {
          formGroup.controls[c].markAsDirty();
          formGroup.controls[c].updateValueAndValidity();
        }
      } else {
        this.validateForm.controls[i].markAsDirty();
        this.validateForm.controls[i].updateValueAndValidity();
      }
    }
    // this.debug('isVideoLinkValid', this.isVideoLinkValid);
    // if (!this.isVideoLinkValid) {
    //   this.validateForm.get('videoLink').setErrors({ incorrect: true });
    // }
    this.debug('imagesList', this.imagesList);
    const imagesNumber = this.imagesList.length;
    this.debug('imagesNumber', imagesNumber);
    if (!imagesNumber) {
      this.validateForm.get('images').setErrors({ required: true });
    } else if (imagesNumber < 3 || this.imagesList.find((image: UploadFile) => image.error)) {
      this.validateForm.get('images').setErrors({ incorrect: true });
    }
    // this.errorModale = this.modalService.error({
    //   nzContent: this.errorModalTpll,
    //   nzIconType: '',
    //   nzMaskClosable: true
    // });
    this.debug('contImage', this.contImage);
    const imagesNumbers = this.contImage.length;
    this.debug('imagesNumbers', imagesNumbers);
    if (!imagesNumbers) {
      this.validateForm.get('doc').setErrors({ required: true });
    } else if (imagesNumbers < 1 || this.contImage.find((image: UploadFile) => image.error)) {
      this.validateForm.get('doc').setErrors({ incorrect: true });
    }
    this.errorModal = this.modalService.error({
      nzContent: this.errorModalTpl,
      nzIconType: '',
      nzMaskClosable: true
    });
  }

  saveForm(event: Event): void {
    if (this.validateForm.valid) {
      (event.target as any).disabled = true; // disallow re-submiting form
      this.isLoading = true; // mark status as loading
      const data = this.validateForm.value;
      data.students.forEach((student: any) => {
        student.birthDate = this.formatDate(student.birthDate);
      });
      // data.images = this.imagesList.map((image: UploadFile) => image.response);
      data.createdAt = Math.round(new Date().getTime() / 1000);//.toString();
      data.archive = false;
      this.debug('data', data);
      this.db.collection('contributions_ecrit').add(data).then((doc: any) => {
        this.debug('doc', doc);
        // Upload images
        let images = [];
        let img = [];
        let promises: Promise<any>[] = [];
        this.imagesList.forEach((image: UploadFile) => {
          //this.debug('image', image, this.imagesFiles[image.uid]);
          const imageExtension = image.name.split('.').pop();
          const imagePath = 'contributions-presse/' + doc.id + '/' + image.uid + '.' + imageExtension;
          const imageFile = this.imagesFiles[image.uid] || image.originFileObj;
          promises.push(
            this.storage.ref(imagePath).put(imageFile).then(() => {
              images.push(imagePath);
            }).catch((error: Error) => {
              console.log(error);
            })
          );
        });
        this.contImage.forEach((image: UploadFile) => {
          //this.debug('image', image, this.imagesFiles[image.uid]);
          const imageExtension = image.name.split('.').pop();
          const imagePath = 'contributions-presse/' + doc.id + '/' + image.uid + '.' + imageExtension;
          const imageFile = this.imageFiles[image.uid] || image.originFileObj;
          promises.push(
            this.storage.ref(imagePath).put(imageFile).then(() => {
              img.push(imagePath);
            }).catch((error: Error) => {
              console.log(error);
            })
          );
        });
        // Once images uploaded
        Promise.all(promises).then(() => {
          // Delete temporary images
          // data.images.forEach((path: string) => {
          //   this.storage.ref(path).delete().toPromise().catch((error: Error) => {
          //     console.log(error);
          //   });
          // });
          // Update doc images
          this.debug('images', images, images.length);
          if (images.length) {
            data.images = images;
          }
          if (img.length) {
            data.doc = img[0];
          }
        }).finally(() => {
          // Update document
          data.id = doc.id;
          doc.set(data);
          // Save cache
          this.formData.setCache(data);
          // Redirect
          this.router.navigate(['success']);
          // Reset status
          this.isLoading = false;
          // Destroy modal
          this.errorModal.destroy();
        });
      }).catch((error) => {
        console.log(error.message);
        this.errorModal.destroy();
      });
    }
  }

  private formatDate(date: Date) {
    return date ? date.getDate() + '/' + (date.getMonth() + 1) + '/' +  date.getFullYear() : date;
  }

  getErrorTip(controlName: string, form: any = null): string {
    if (form === null) {
      form = this.validateForm;
    }
    if (form.controls[controlName] && form.controls[controlName].errors) {
      if (form.controls[controlName].errors.required) {
        return 'هذه الخانة إجبارية';
      } else {
        return 'هذه القيمة غير صحيحة';
      }
    } else {
      return null;
    }
  }

  getClass(controlName: string, form: any = null, element: any = null): object {
    if (form === null) {
      form = this.validateForm;
    }
    if (form.controls[controlName]) {
      return {
        'not-empty': form.controls[controlName].value && form.controls[controlName].value.toString().length,
        'is-open': element && element.open
      };
    } else {
      return {};
    }
  }

  getStudents(): FormArray {
    return this.validateForm.get('students') as FormArray;
  }

  addStudent(event: Event): void {
    event.preventDefault();
    const students = this.getStudents();
    students.push(this.createStudentForm());
  }

  removeStudent(event: Event): void {
    event.preventDefault();
    const students = this.getStudents();
    students.removeAt(students.length - 1);
  }

  datePickerClick(datePicker: any): void {
    datePicker.picker.pickerInput.nativeElement.click();
  }

  uploadImage = (item: UploadXHRArgs) => {
    this.debug('uploading', item);
    // const fileExtension = item.file.name.split('.').pop();
    // const filePath = 'contributions-video/tmp/' + item.file.uid + '.' + fileExtension;
    // this.subscriptions.push(
    //   // Upload file
    //   this.storage.ref(filePath).put(item.file).percentageChanges().pipe(map(s => s)).subscribe((progress: any) => {
    //     //this.debug(progress);
    //     if (progress == 100) {
    //       item.onSuccess!(filePath, item.file!, item);
    //       this.validateForm.get('images').reset();
    //       //this.validateForm.updateValueAndValidity();
    //     } else {
    //       //const percent = (progress.bytesTransferred / progress.totalBytes) * 100;
    //       item.onProgress!({ percent: progress }, item.file!);
    //     }
    //   }, error => {
    //     item.onError!(error, item.file!);
    //   })
    // );
    setTimeout(() => { // set timeout used here to wait for file upload setup by the nz-upload component (otherwise the code below will throw an error)
      // this is a fake upload (we don't really need to upload images before, since we gonna re-upload them on save)
      this.imageFiles[item.file.uid] = item.file; // save image file (to use it on real upload)
      //this.debug('file', this.imagesFiles[item.file.uid]);
      item.onProgress!({ percent: 100 }, item.file!);
      item.onSuccess!(item.file.name, item.file!, item);
      this.validateForm.get('doc').reset();
      //this.validateForm.updateValueAndValidity();
    }, 100);
  };
  uploadImages = (item: UploadXHRArgs) => {
    this.debug('uploading', item);
    // const fileExtension = item.file.name.split('.').pop();
    // const filePath = 'contributions-video/tmp/' + item.file.uid + '.' + fileExtension;
    // this.subscriptions.push(
    //   // Upload file
    //   this.storage.ref(filePath).put(item.file).percentageChanges().pipe(map(s => s)).subscribe((progress: any) => {
    //     //this.debug(progress);
    //     if (progress == 100) {
    //       item.onSuccess!(filePath, item.file!, item);
    //       this.validateForm.get('images').reset();
    //       //this.validateForm.updateValueAndValidity();
    //     } else {
    //       //const percent = (progress.bytesTransferred / progress.totalBytes) * 100;
    //       item.onProgress!({ percent: progress }, item.file!);
    //     }
    //   }, error => {
    //     item.onError!(error, item.file!);
    //   })
    // );
    setTimeout(() => { // set timeout used here to wait for file upload setup by the nz-upload component (otherwise the code below will throw an error)
      // this is a fake upload (we don't really need to upload images before, since we gonna re-upload them on save)
      this.imagesFiles[item.file.uid] = item.file; // save image file (to use it on real upload)
      //this.debug('file', this.imagesFiles[item.file.uid]);
      item.onProgress!({ percent: 100 }, item.file!);
      item.onSuccess!(item.file.name, item.file!, item);
      this.validateForm.get('images').reset();
      //this.validateForm.updateValueAndValidity();
    }, 100);
  };

  handleImagesChange(info: { file: UploadFile }): void {
    // this.debug(info);
    // switch (info.file.status) {
    //   case 'uploading':
    //     break;
    //   case 'done':
    //     break;
    //   case 'error':
    //     break;
    // }
  }

  removeImage = (file: UploadFile): boolean|Observable<boolean> => {
    this.debug('removing', file);
    // if (file.error) {
    //   return true;
    // } else {
    //   const filePath = file.response;
    //   const done = new Subject<boolean>();
    //   this.storage.ref(filePath).delete().toPromise().then(() => {
    //     done.next(true);
    //   }).catch((error: Error) => {
    //     console.log(error);
    //     done.next(false);
    //   });
    //   return done.asObservable();
    // }
    return true;
  };

  handleImagePreview = (file: UploadFile) => {
    this.imagePreview = file.url || file.thumbUrl;
    this.isImagePreviewVisible = true;
  };

  private debug(message: string, ...params: any): void {
    !environment.production && console.log(message, ...params);
  }

  handleChange({ file, fileList }: UploadChangeParam): void {
    const status = file.status;
    this.contImage = fileList;
    console.log('status = ',status);
    if (status !== 'uploading') {
      console.log(file, fileList);
    }
    if (status === 'done') {
      this.msg.success(`${file.name} file uploaded successfully.`);
    } else if (status === 'error') {
      this.msg.error(`${file.name} file upload failed.`);
    }
  }

}
